export default __webpack_public_path__ + "static/media/PRZYMIERZE.9e6cf521.png";